module.exports = __webpack_public_path__ + "img/header-bg-img-retail.072016f9.png";